<template>
  <div class="main-navigation d-md-none" style="z-index: 101; display:none;">
    <div class="wrapper">
      <div class="row">
        <div class="col text-center">
          <a href="https://masjed.id" class="link-block">
            <img :src="'/img/beranda.svg'" alt="icons" /><br />
            <span class="icon-text">Beranda</span>
          </a>
        </div>
        <div class="col text-center">
          <a href="https://masjed.id/app/profil/index" class="link-block">
            <img :src="'/img/riwayat.svg'" alt="icons" /><br />
            <!-- <i class="uil uil-history icon-nav"></i> -->
            <span class="icon-text">Riwayat</span>
          </a>
        </div>
        <div class="col text-center relative-box">
          <a
            href="https://masjed.id/app/mupays/myqr"
            class="link-block qris-link"
          >
            <img :src="'/img/qris.svg'" alt="icons" /><br />
            <!-- <i class="uil uil-qrcode-scan icon-nav main-icon-nav bg-main"></i> -->
            <span class="icon-text">MyQris</span>
          </a>
        </div>
        <div class="col text-center">
          <a href="https://masjed.id/app/notifikasi" class="link-block">
            <img :src="'/img/notifikasi.svg'" alt="icons" /><br />
            <span class="icon-text">Notifikasi</span>
          </a>
        </div>
        <div class="col text-center">
          <a href="https://masjed.id/app/profil/index" class="link-block">
            <img :src="'/img/profil.svg'" alt="icons" /><br />
            <span class="icon-text">Profil</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
